import type { LanguageOption } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/types";

export const DEFAULT_LANGUAGE = "Platform default";

export const LANGUAGES: LanguageOption[] = [
    { id: DEFAULT_LANGUAGE, text: "Platform default" },
    { id: "en", text: "English" },
    { id: "sq", text: "Shqip" },
    { id: "am", text: "አማርኛ" },
    { id: "ar", text: "العربية" },
    { id: "hy", text: "Հայերեն" },
    { id: "bn", text: "বাংলা" },
    { id: "bs", text: "Bosanski" },
    { id: "bg", text: "Български" },
    { id: "my", text: "ဗမာ" },
    { id: "ca", text: "Català" },
    { id: "zh", text: "中文" },
    { id: "hr", text: "Hrvatski" },
    { id: "cs", text: "Čeština" },
    { id: "da", text: "Dansk" },
    { id: "nl", text: "Nederlands" },
    { id: "et", text: "Eesti" },
    { id: "fi", text: "Suomi" },
    { id: "fr", text: "Français" },
    { id: "ka", text: "ქართული" },
    { id: "de", text: "Deutsch" },
    { id: "el", text: "Ελληνικά" },
    { id: "gu", text: "ગુજરાતી" },
    { id: "he", text: "עברית" },
    { id: "hi", text: "हिन्दी" },
    { id: "hu", text: "Magyar" },
    { id: "is", text: "Íslenska" },
    { id: "id", text: "Bahasa Indonesia" },
    { id: "it", text: "Italiano" },
    { id: "ja", text: "日本語" },
    { id: "kn", text: "ಕನ್ನಡ" },
    { id: "kk", text: "Қазақ тілі" },
    { id: "ko", text: "한국어" },
    { id: "lv", text: "Latviešu" },
    { id: "lt", text: "Lietuvių" },
    { id: "mk", text: "Македонски" },
    { id: "ms", text: "Bahasa Melayu" },
    { id: "ml", text: "മലയാളം" },
    { id: "mr", text: "मराठी" },
    { id: "mn", text: "Монгол" },
    { id: "no", text: "Norsk" },
    { id: "fa", text: "فارسی" },
    { id: "pl", text: "Polski" },
    { id: "pt", text: "Português" },
    { id: "pa", text: "ਪੰਜਾਬੀ" },
    { id: "ro", text: "Română" },
    { id: "ru", text: "Русский" },
    { id: "sr", text: "Српски" },
    { id: "sk", text: "Slovenčina" },
    { id: "sl", text: "Slovenščina" },
    { id: "so", text: "Soomaali" },
    { id: "es", text: "Español" },
    { id: "sw", text: "Kiswahili" },
    { id: "sv", text: "Svenska" },
    { id: "tl", text: "Tagalog" },
    { id: "ta", text: "தமிழ்" },
    { id: "te", text: "తెలుగు" },
    { id: "th", text: "ไทย" },
    { id: "tr", text: "Türkçe" },
    { id: "uk", text: "Українська" },
    { id: "ur", text: "اردو" },
    { id: "vi", text: "Tiếng Việt" },
];
